/* eslint-disable */

import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import {
  fetchAuthenticationSignUp,
  fetchGraphQL,
} from "../../../services/api-raindrop";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import { Size } from "../../../logic/enums.ts";

import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration.js";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import VersionDisplay from "../../../ui-components/version-display/version-display.js";
import {
  generateFakeFirstName,
  generateFakeLastName,
  generateFakeNumber,
} from "../../../logic/logic.js";

import RaindropCardVerifyEmail from "../../../ui-components/raindrop-card-verify-email/raindrop-card-verify-email.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";

enum Stage {
  SignUp,
  VerifyEmail,
}

const AlreadyHaveAnAccount = () => {
  return (
    <div className="flex flex-row gap-2 w-full items-center justify-center">
      <RaindropTextParagraph isFluid={false}>
        Already have an account?
      </RaindropTextParagraph>
      <Link to="/raindrop/login">
        <div className="font-black text-color-raindrop-primary text-lg">
          Log In
        </div>
      </Link>
    </div>
  );
};

const RaindropSignUpFormCard = ({
  inputEmail = "",
  setInputEmail = (x) => {},
  setStage = (x) => {},
  setLocalMagicLink = (x) => {},
}) => {
  const [inputFirstName, setInputFirstName] = useState("");
  const [inputLastName, setInputLastName] = useState("");
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [inputConfirmPassword, setInputConfirmPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const fakeFirstName = generateFakeFirstName();
  const fakeLastName = generateFakeLastName();
  const fakeNumber = generateFakeNumber();

  const onSubmit = () => {
    if (!inputEmail || !inputFirstName || !inputLastName) {
      setErrorMessage("Please fill in all fields");
      return;
    }

    if (inputPassword !== inputConfirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    if (inputPassword.length < 8) {
      setErrorMessage("Password must be at least 8 characters");
      return;
    }

    fetchGraphQL(`
      mutation {
        createAccount(
          email: "${inputEmail}"
          firstName: "${inputFirstName}"
          lastName: "${inputLastName}"
          username: "${inputUsername}"
          rawPassword: "${inputPassword}"
        )
      }
    `).then((response) => {
      if (response.errors) {
        console.error(response.errors);
        setErrorMessage("Something went wrong, please try again");
        return;
      }

      setLocalMagicLink(response.data.createAccount);
      setStage(Stage.VerifyEmail);
    });
  };

  return (
    <div className="flex flex-col gap-8 ">
      <RaindropMotionFadeUp delay={0.4}>
        <RaindropCard additionalClasses="gap-8 py-4 ">
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col pb-2">
              <RaindropTextHeading1>Create an account</RaindropTextHeading1>

              <RaindropTextSubtitle>
                We'll send you a link to verify
              </RaindropTextSubtitle>
            </div>
            <RaindropInput
              placeholder="Email"
              isAnimationEnabled={false}
              value={inputEmail}
              onChange={(e) => {
                setInputEmail(e.target.value);
              }}
              isPopulatingExampleIfLocal={true}
              example={`${fakeFirstName}.${fakeLastName}.${fakeNumber}@example.com`}
            />
            <div className="flex flex-row gap-2">
              <RaindropInput
                placeholder="First name"
                isAnimationEnabled={false}
                value={inputFirstName}
                onChange={(e) => {
                  setInputFirstName(
                    e.target.value.replace(/\s/g, "").replace(/[^a-zA-Z]/g, "")
                  );
                }}
                maxLength={30}
                isPopulatingExampleIfLocal={true}
                example={fakeFirstName}
              />
              <RaindropInput
                placeholder="Last name"
                isAnimationEnabled={false}
                value={inputLastName}
                onChange={(e) => {
                  setInputLastName(
                    e.target.value.replace(/\s/g, "").replace(/[^a-zA-Z]/g, "")
                  );
                }}
                maxLength={30}
                isPopulatingExampleIfLocal={true}
                example={fakeLastName}
              />
            </div>
            <RaindropInput
              placeholder="Username"
              isAnimationEnabled={false}
              value={inputUsername}
              onChange={(e) => {
                setInputUsername(
                  e.target.value
                    .toLowerCase()
                    .replace(/\s/g, "")
                    .replace(/[^a-z0-9]/g, "")
                );
              }}
              maxLength={30}
              minLength={8}
              isPopulatingExampleIfLocal={true}
              example={`${fakeFirstName}${fakeLastName}${fakeNumber}`}
            />
            <RaindropInput
              placeholder="Password"
              isAnimationEnabled={false}
              isPassword={true}
              isRevealable={true}
              isFluid={true}
              value={inputPassword}
              onChange={(e) => {
                setInputPassword(e.target.value);
              }}
              maxLength={100}
              minLength={8}
              isPopulatingExampleIfLocal={true}
              example="Flying-catapillar-eats-lots-of-carrots-123&"
            />
            <RaindropInput
              placeholder="Confirm Password"
              isAnimationEnabled={false}
              isPassword={true}
              isRevealable={true}
              isFluid={true}
              value={inputConfirmPassword}
              onChange={(e) => {
                setInputConfirmPassword(e.target.value);
              }}
              maxLength={100}
              isPopulatingExampleIfLocal={true}
              example="Flying-catapillar-eats-lots-of-carrots-123&"
            />

            {errorMessage && (
              <div className="flex flex-row gap-2 w-full items-center justify-start">
                <div className="w-2 h-2 rounded-full bg-color-error" />

                <p className="text-color-error font-bold text-sm">
                  {errorMessage}
                </p>
              </div>
            )}
          </div>

          <RaindropMotionFadeUp delay={0.6}>
            <RaindropButton
              title="Sign Up"
              size={Size.Large}
              onClick={onSubmit}
              isFluid={true}
              style={ButtonStyle.Primary}
            />
          </RaindropMotionFadeUp>
        </RaindropCard>
      </RaindropMotionFadeUp>
    </div>
  );
};

const RaindropHeader = () => {
  return (
    <RaindropMotionFadeUp delay={0.2}>
      <RaindropTitle
        isPrimary={true}
        size={Size.Large}
        isIncludingVersion={true}
      />
    </RaindropMotionFadeUp>
  );
};

const RaindropSignUp = () => {
  const [stage, setStage] = useState(Stage.SignUp);

  const [localMagicLink, setLocalMagicLink] = useState<string | null>(null);

  const [inputEmail, setInputEmail] = useState("");

  return (
    <div className="flex flex-col h-full w-full px-4 py-8 pt-8  overflow-y-auto no-scrollbar items-center ">
      <div className="flex flex-col w-full max-w-sm gap-10">
        <RaindropHeader />

        {stage === Stage.SignUp && (
          <RaindropSignUpFormCard
            inputEmail={inputEmail}
            setInputEmail={setInputEmail}
            setStage={setStage}
            setLocalMagicLink={setLocalMagicLink}
          />
        )}

        {stage === Stage.VerifyEmail && (
          <RaindropCardVerifyEmail
            inputEmail={inputEmail}
            localMagicLink={localMagicLink}
            isSignup={true}
          />
        )}

        <AlreadyHaveAnAccount />

        <RaindropCopyrightDeclaration />
      </div>
    </div>
  );
};

export default RaindropSignUp;
